var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoPrueba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0078 -0.000488281C26.8358 -0.000488281 27.5078 0.671512 27.5078 1.49951V28.4995C27.5078 29.3275 26.8358 29.9995 26.0078 29.9995H5.00781C4.17981 29.9995 3.50781 29.3275 3.50781 28.4995V25.4995H0.507812V22.4995H3.50781V19.4995H0.507812V16.4995H3.50781V13.4995H0.507812V10.4995H3.50781V7.49951H0.507812V4.49951H3.50781V1.49951C3.50781 0.671512 4.17981 -0.000488281 5.00781 -0.000488281H26.0078ZM24.5078 2.99951H6.50781V26.9995H24.5078V2.99951ZM17.0078 8.99951V13.4995H21.5078V16.4995H17.0063L17.0078 20.9995H14.0078L14.0063 16.4995H9.50781V13.4995H14.0078V8.99951H17.0078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPrueba);
export default __webpack_public_path__ + "static/media/IconoPrueba.8ad79e448f1e4b237b3967a432d857ff.svg";
export { ForwardRef as ReactComponent };